module.exports = __webpack_public_path__ + "static/img/8.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/sp/8.png
// module id = wyy8
// module chunks = 0